var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiscellaneous(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2541 10.8748L11.4863 12.6426L16.4832 17.6394L18.2509 15.8717L13.2541 10.8748Z",
    fill: "#017a4e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 8.33301C16.1917 8.33301 17.5 7.02467 17.5 5.41634C17.5 4.93301 17.3667 4.48301 17.1583 4.08301L14.9083 6.33301L13.6667 5.09134L15.9167 2.84134C15.5167 2.63301 15.0667 2.49967 14.5833 2.49967C12.975 2.49967 11.6667 3.80801 11.6667 5.41634C11.6667 5.75801 11.7333 6.08301 11.8417 6.38301L10.3 7.92467L8.81667 6.44134L9.40833 5.84967L8.23333 4.67467L10 2.90801C9.025 1.93301 7.44167 1.93301 6.46667 2.90801L3.51667 5.85801L4.69167 7.03301H2.34167L1.75 7.62467L4.7 10.5747L5.29167 9.98301V7.62467L6.46667 8.79967L7.05833 8.20801L8.54167 9.69134L2.36667 15.8663L4.13333 17.633L13.6167 8.15801C13.9167 8.26634 14.2417 8.33301 14.5833 8.33301Z",
    fill: "#017a4e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscellaneous);
export default __webpack_public_path__ + "static/media/miscellaneous.9cf5e9ecd7389f89fef8d392fc7c7ba0.svg";
export { ForwardRef as ReactComponent };